module.exports = __webpack_public_path__ + "static/media/ic_service_types.688636ca.png";